import React, { useState } from 'react';
import { Card, Tabs, Row, Col, Select, DatePicker, Button, Table, Tag, Space, Statistic, Divider } from 'antd';
import { SearchOutlined, TeamOutlined, UserOutlined, AreaChartOutlined, HistoryOutlined, VideoCameraOutlined } from '@ant-design/icons';
import ReactECharts from 'echarts-for-react';

const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

const PeopleFlowDetection = () => {
  const [activeTab, setActiveTab] = useState('realtime');
  const [loading, setLoading] = useState(false);

  // 模拟数据 - 实时人流检测记录
  const realtimeData = [
    {
      id: 1,
      cameraName: '前门监控',
      location: '大楼前门',
      personCount: 15,
      timestamp: '2025-03-18 15:22:50',
      screenshot: 'https://via.placeholder.com/150',
    },
    {
      id: 2,
      cameraName: '前门监控',
      location: '大楼前门',
      personCount: 12,
      timestamp: '2025-03-18 15:22:40',
      screenshot: 'https://via.placeholder.com/150',
    },
    {
      id: 3,
      cameraName: '前门监控',
      location: '大楼前门',
      personCount: 10,
      timestamp: '2025-03-18 15:22:30',
      screenshot: 'https://via.placeholder.com/150',
    },
    {
      id: 4,
      cameraName: '前门监控',
      location: '大楼前门',
      personCount: 8,
      timestamp: '2025-03-18 15:22:25',
      screenshot: 'https://via.placeholder.com/150',
    },
    {
      id: 5,
      cameraName: '前门监控',
      location: '大楼前门',
      personCount: 6,
      timestamp: '2025-03-18 15:22:15',
      screenshot: 'https://via.placeholder.com/150',
    },
    {
      id: 6,
      cameraName: '前门监控',
      location: '大楼前门',
      personCount: 5,
      timestamp: '2025-03-18 15:22:10',
      screenshot: 'https://via.placeholder.com/150',
    },
    {
      id: 7,
      cameraName: '前门监控',
      location: '大楼前门',
      personCount: 4,
      timestamp: '2025-03-18 15:22:00',
      screenshot: 'https://via.placeholder.com/150',
    },
    {
      id: 8,
      cameraName: '前门监控',
      location: '大楼前门',
      personCount: 3,
      timestamp: '2025-03-18 15:21:55',
      screenshot: 'https://via.placeholder.com/150',
    },
  ];

  // 模拟数据 - 人脸识别记录
  const faceRecognitionData = [
    {
      id: 1,
      personId: 92,
      name: 'test1',
      phone: '17632312345',
      entryTime: '2024-01-22 15:02:36',
      exitTime: '2024-01-22 15:02:37',
      duration: '1秒',
      avatar: 'https://via.placeholder.com/50',
    },
    {
      id: 2,
      personId: 92,
      name: 'test2',
      phone: '17612352321',
      entryTime: '2024-01-22 14:52:18',
      exitTime: '2024-01-22 14:52:19',
      duration: '1秒',
      avatar: 'https://via.placeholder.com/50',
    },
  ];

  // 实时人流检测表格列
  const realtimeColumns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: '摄像头',
      dataIndex: 'cameraName',
      key: 'cameraName',
    },
    {
      title: '位置',
      dataIndex: 'location',
      key: 'location',
    },
    {
      title: '人数',
      dataIndex: 'personCount',
      key: 'personCount',
      render: (count) => {
        let color = 'green';
        if (count > 10) {
          color = 'red';
        } else if (count > 5) {
          color = 'orange';
        }
        return <Tag color={color}>{count}</Tag>;
      },
    },
    {
      title: '时间',
      dataIndex: 'timestamp',
      key: 'timestamp',
    },
    {
      title: '截图',
      dataIndex: 'screenshot',
      key: 'screenshot',
      render: (text) => <img src={text} alt="截图" style={{ width: 100, height: 60, objectFit: 'cover' }} />,
    },
  ];

  // 人脸识别表格列
  const faceRecognitionColumns = [
    {
      title: '序号',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      title: '头像',
      dataIndex: 'avatar',
      key: 'avatar',
      render: (text) => <img src={text} alt="头像" style={{ width: 50, height: 50, borderRadius: '50%' }} />,
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: '进入时间',
      dataIndex: 'entryTime',
      key: 'entryTime',
    },
    {
      title: '离开时间',
      dataIndex: 'exitTime',
      key: 'exitTime',
    },
    {
      title: '在场时间',
      dataIndex: 'duration',
      key: 'duration',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="small">
          <Button type="link" size="small">编辑</Button>
          <Button type="link" size="small">详情</Button>
          <Button type="link" danger size="small">删除</Button>
        </Space>
      ),
    },
  ];

  // 人流统计图表配置
  const getFlowOption = () => {
    return {
      title: {
        text: '人流统计',
        left: 'center'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['前门', '后门', '侧门'],
        bottom: 10
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '15%',
        top: '15%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00']
      },
      yAxis: {
        type: 'value',
        name: '人数'
      },
      series: [
        {
          name: '前门',
          type: 'line',
          data: [5, 12, 15, 10, 8, 13, 17, 15]
        },
        {
          name: '后门',
          type: 'line',
          data: [3, 5, 7, 8, 6, 5, 8, 10]
        },
        {
          name: '侧门',
          type: 'line',
          data: [1, 3, 4, 5, 3, 4, 6, 7]
        }
      ]
    };
  };

  // 人流分布图表配置
  const getDistributionOption = () => {
    return {
      title: {
        text: '人流分布',
        left: 'center'
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        orient: 'vertical',
        left: 'left',
      },
      series: [
        {
          name: '人流分布',
          type: 'pie',
          radius: '50%',
          data: [
            { value: 45, name: '前门区域' },
            { value: 25, name: '后门区域' },
            { value: 15, name: '侧门区域' },
            { value: 10, name: '电梯区域' },
            { value: 5, name: '其他区域' }
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  };

  return (
    <div>
      <Card title="人流检测">
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane 
            tab={
              <span>
                <TeamOutlined />
                实时人流检测
              </span>
            } 
            key="realtime"
          >
            <div className="search-bar">
              <Space>
                <Select 
                  placeholder="选择摄像头" 
                  style={{ width: 200 }}
                  allowClear
                >
                  <Option value="前门监控">前门监控</Option>
                  <Option value="后门监控">后门监控</Option>
                  <Option value="侧门监控">侧门监控</Option>
                  <Option value="电梯监控">电梯监控</Option>
                </Select>
                <RangePicker showTime />
                <Button type="primary" icon={<SearchOutlined />}>搜索</Button>
                <Button>重置</Button>
              </Space>
            </div>

            <Row gutter={16} style={{ marginTop: 16, marginBottom: 16 }}>
              <Col span={6}>
                <Card>
                  <Statistic 
                    title="当前人数" 
                    value={53} 
                    prefix={<TeamOutlined />} 
                    valueStyle={{ color: '#1890ff' }}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card>
                  <Statistic 
                    title="今日人数" 
                    value={78} 
                    prefix={<AreaChartOutlined />}
                    valueStyle={{ color: '#52c41a' }}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card>
                  <Statistic 
                    title="当前人流" 
                    value={15} 
                    prefix={<UserOutlined />}
                    valueStyle={{ color: '#faad14' }}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card>
                  <Statistic 
                    title="当前摄像头" 
                    value={4} 
                    prefix={<VideoCameraOutlined />}
                    valueStyle={{ color: '#722ed1' }}
                  />
                </Card>
              </Col>
            </Row>

            <Table 
              columns={realtimeColumns} 
              dataSource={realtimeData} 
              rowKey="id" 
              loading={loading}
              pagination={{ pageSize: 8 }}
            />
          </TabPane>

          <TabPane 
            tab={
              <span>
                <UserOutlined />
                人脸识别
              </span>
            } 
            key="face"
          >
            <div className="search-bar">
              <Space>
                <Select 
                  placeholder="选择摄像头" 
                  style={{ width: 200 }}
                  allowClear
                >
                  <Option value="前门监控">前门监控</Option>
                  <Option value="后门监控">后门监控</Option>
                  <Option value="侧门监控">侧门监控</Option>
                  <Option value="电梯监控">电梯监控</Option>
                </Select>
                <RangePicker showTime />
                <Button type="primary" icon={<SearchOutlined />}>搜索</Button>
                <Button>重置</Button>
              </Space>
            </div>

            <Table 
              columns={faceRecognitionColumns} 
              dataSource={faceRecognitionData} 
              rowKey="id" 
              loading={loading}
              pagination={{ pageSize: 10 }}
            />
          </TabPane>

          <TabPane 
            tab={
              <span>
                <AreaChartOutlined />
                统计分析
              </span>
            } 
            key="statistics"
          >
            <div className="search-bar">
              <Space>
                <Select 
                  placeholder="选择摄像头" 
                  style={{ width: 200 }}
                  allowClear
                  mode="multiple"
                >
                  <Option value="前门监控">前门监控</Option>
                  <Option value="后门监控">后门监控</Option>
                  <Option value="侧门监控">侧门监控</Option>
                  <Option value="电梯监控">电梯监控</Option>
                </Select>
                <RangePicker showTime />
                <Select placeholder="选择统计类型" style={{ width: 120 }}>
                  <Option value="hour">按小时</Option>
                  <Option value="day">按天</Option>
                  <Option value="week">按周</Option>
                  <Option value="month">按月</Option>
                </Select>
                <Button type="primary" icon={<SearchOutlined />}>搜索</Button>
                <Button>重置</Button>
              </Space>
            </div>

            <Divider orientation="left">人流统计图</Divider>
            <ReactECharts option={getFlowOption()} style={{ height: 400 }} />

            <Divider orientation="left">人流分布图</Divider>
            <ReactECharts option={getDistributionOption()} style={{ height: 400 }} />
          </TabPane>

          <TabPane 
            tab={
              <span>
                <HistoryOutlined />
                历史记录
              </span>
            } 
            key="history"
          >
            <div className="search-bar">
              <Space>
                <Select 
                  placeholder="选择摄像头" 
                  style={{ width: 200 }}
                  allowClear
                >
                  <Option value="前门监控">前门监控</Option>
                  <Option value="后门监控">后门监控</Option>
                  <Option value="侧门监控">侧门监控</Option>
                  <Option value="电梯监控">电梯监控</Option>
                </Select>
                <RangePicker showTime />
                <Button type="primary" icon={<SearchOutlined />}>搜索</Button>
                <Button>重置</Button>
              </Space>
            </div>

            <Table 
              columns={realtimeColumns} 
              dataSource={realtimeData} 
              rowKey="id" 
              loading={loading}
              pagination={{ pageSize: 10 }}
            />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default PeopleFlowDetection;
